var map = {
	"./kz-KZ": [
		786,
		0
	],
	"./kz-KZ.js": [
		786,
		0
	],
	"./ru-RU": [
		787,
		1
	],
	"./ru-RU.js": [
		787,
		1
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1524;
module.exports = webpackAsyncContext;